import { LightBulbSvg } from '../svg/lightBulb.svg';
import { IconPropsDeprecated } from '@umanforge/common';

export const HighlightIcon = ( { className = 'w-5 h-5 text-yellow-600', size, onClick }: IconPropsDeprecated ) => {
  return (
    <LightBulbSvg
      className={ className }
      size={ size }
      onClick={ onClick }
    />
  );
};
